document.addEventListener("DOMContentLoaded", () => {
    const textarea = document.getElementById("message");
    const placeholder = document.querySelector(".placeholder");
  
    // Ensure both elements exist
    if (!textarea || !placeholder) {
      return;
    }
  
    // Function to toggle the placeholder visibility
    function togglePlaceholder() {
      const hasValue = textarea.value.trim() !== "";
      if (hasValue) {
        placeholder.classList.add("hidden");
      } else {
        placeholder.classList.remove("hidden");
      }
    }
  
    // Function to handle focus styling
    function handleFocus() {
        placeholder.classList.add("hidden");
    }
  
    // Function to handle blur styling
    function handleBlur() {
        placeholder.classList.remove("hidden");
        togglePlaceholder(); // Ensure visibility is correctly updated
    }
  
    // Run initially in case the textarea is pre-filled
    togglePlaceholder();
  
    // Attach event listeners
    textarea.addEventListener("input", togglePlaceholder);
    textarea.addEventListener("focus", handleFocus);
    textarea.addEventListener("blur", handleBlur);
  });
  